
export type QueryMetrics401 = {
  error?: string;
};
